var path = 'areas/shared/views/octo-form.html';
var html = "<div> <div ng-repeat=\"element in formElements\"> <interruption-field submit=submit is-submitting=isSubmitting is-disabled=isFormDisabled element=element></interruption-field> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/octo-form.html
// module id = 972
// module chunks = 1